export default __webpack_public_path__ + "static/media/premium-logistics-cta-branded.c2d2ac77.jpg";